import React, { useState } from 'react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import SEO from './SEO';
import AumSavingsCard, { AUM_DEFAULT } from './AumSavingsCard';

const HUBSPOT_MEETING_SRC = 'https://meetings.hubspot.com/amorjaria/sharpemetrix?embed=true';

export default function BookDiscoveryPage() {
  const [aum, setAum] = useState(AUM_DEFAULT);

  return (
    <>
      <SEO
        title="Book a Discovery Call"
        description="Book a 20-minute SharpeMetrix discovery call and see how much you could save versus a typical TAMP fee."
        url="/book-discovery"
      />
      <div className="min-h-screen bg-bg-100 flex flex-col">
        <div className="flex items-center px-6 py-4 border-b border-bg-300">
          <img src="/logo_wordmark.svg" alt="SharpeMetrix" className="h-7" />
        </div>

        <div className="flex-1 px-6 py-8 lg:py-12">
          <div className="mx-auto max-w-6xl">
            <div className="mb-8 max-w-2xl">
              <p className="text-primary-100 text-sm font-medium mb-1">Discovery call</p>
              <h1 className="text-3xl font-bold text-text-100">Book a time with the team</h1>
              <p className="mt-2 text-text-200">
                Pick a slot that works — we'll walk through the models, the signals, and how advisors use SharpeMetrix.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
              <div className="lg:col-span-7">
                <div className="rounded-2xl border border-bg-300 bg-bg-200 overflow-hidden">
                  <div className="px-5 py-4 border-b border-bg-300 flex items-center gap-3">
                    <CalendarDaysIcon className="w-5 h-5 text-primary-100" />
                    <div>
                      <p className="text-sm font-semibold text-text-100">Amar Morjaria · SharpeMetrix</p>
                      <p className="text-xs text-text-300">20-minute discovery call</p>
                    </div>
                  </div>
                  <div className="meetings-iframe-container relative h-[780px] overflow-hidden bg-white">
                    <iframe
                      title="Book a SharpeMetrix discovery call"
                      src={HUBSPOT_MEETING_SRC}
                      scrolling="no"
                      className="absolute inset-0 h-full w-full border-0"
                    />
                  </div>
                </div>
              </div>

              <aside className="lg:col-span-5">
                <AumSavingsCard aum={aum} onChange={setAum} />
              </aside>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
